import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import {
  LocalStorageKeys,
  localStorageHelper,
} from "@src/helper/localStorage.helper";
import { useMemo } from "react";
import style from "./LoadingPageAfterPaiement.module.scss";

export function LoadingPageAfterPaiement() {
  const isAlreadyPaid = useMemo(
    () =>
      localStorageHelper.getItem(
        LocalStorageKeys.CREATION_ENTREPRISES_TYPE_PAIEMENT
      ) === "CB",
    []
  );

  return (
    <div className={style.page}>
      <div className={style.pageContent}>
        <Loader className={style.loader} />
        <h2>
          {isAlreadyPaid && "Votre paiement a bien été accepté. "}
          Veuillez patienter.
        </h2>
        <p className={style.durationInfo}>
          Nous en avons pour moins d&apos;une minute.
        </p>
      </div>
      <div className={style.pageBottom}>
        <p className={style.moreInfo}>
          Si la page de confirmation de renouvellement ne s&apos;affiche pas,
          merci de contacter :{" "}
          <a
            href="mailto:support@endya.fr"
            onClick={(e) => {
              window.open("mailto:support@endya.fr", "mail");
              e.preventDefault();
            }}
            className={style.link}
          >
            support@endya.fr
          </a>
        </p>
      </div>
    </div>
  );
}
